import React from "react";

function Fl({ children }) {
    return <div className="fl Lnb">{children}</div>;
}

export default Fl;
